import { React, useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
import { LocationTable, LocationCreate } from "..";


function LocationsSearch() {
  const [locationName, setLocationName] = useState("");

  const [locations, setLocations] = useState([]);
  const [updateTable, setUpdateTable] = useState(false);

  useEffect(() => {
    showLocationsSearchResults();
  }, [locationName, updateTable]);

  const showLocationsSearchResults = () => {
    const body = new FormData();
    body.append("locationName", locationName);

    axios.post("/faculty/searchLocations", body).then((res) => {
      const data = res.data;
      if (data.success) {
        setLocations(data.locations);
      } else {
      }
    });
  };

  const resetHooks = () => {
    setLocationName("");
  };

  return (
    <div className="LocationsSearch bg-brand-tertiary h-full">
      <div className="LocationsSearch-container flex flex-col p-8 h-full">
        <div className="LocationsSearch-topContainer flex flex-wrap">
          <div className="LocationsSearch-searchBar flex search-button h-11 mr-4 w-60 mb-4">
            <input
              type="text"
              className="font-brand-quaternary h-full rounded-full ml-4 w-full"
              placeholder="Search"
              value={locationName}
              onChange={(e) => setLocationName(e.target.value)}
            />
            <div className="my-auto mx-2">
              <SearchIcon size={16} />
            </div>
          </div>

          <LocationCreate updateTable={updateTable} setUpdateTable={setUpdateTable} />

          <button type="button"
            className="search-button px-4 h-11 mb-4 text-center py-2" onClick={resetHooks}>
            Reset Search
          </button>
        </div>
        <div className="LocationsSearch-bottomContainer flex w-full h-full">
          <LocationTable locations={locations} updateTable={updateTable} setUpdateTable={setUpdateTable} />
        </div>
      </div>
    </div>
  );
}

export default LocationsSearch;
